import "../../../../content/projects/melwin/melwin.css";
import * as React from 'react';
export default {
  React
};